import { createSlice } from '@reduxjs/toolkit';

const initialValues = {
    trainerOracle: '',
    ogOracle:'',
    tcpOracle: '',
    techEquipmentSolution : '',
    distributionType : '',
    networkType : '',
    applyAll : false,
    accDate : '',
    tciDate : '',
    tciRecoveryDate : '',
    tpcRecoveryDate : '',
    ttdBotDate : '',
    ttdRecoveryDate : '',
    tpcDate : '',
    ttfDate : '',
    productTrainingDate : '',
    nestingDate : '',
    nestingEndDate : '',
    productionStartDate : '',
    tciZoomLink : '',
    tciZoomPw : '',
    tciRecoveryZoomLink : '',
    tciRecoveryZoomPw :'',
    ttdZoomLink : '',
    ttdZoomPw : '',
    ttdRecoveryZoomLink: '',
    ttdRecoveryZoomPw : '',
    tpcZoomLink : '',
    tpcZoomPw : '',
    ttfZoomLink:'',
    ttfZoomPw : '',
    ttfHostKey :'',
    tpcHostKey :'',
    modifiedBy : '',
    classRosterId : '',
    wave : '',
    productionTrainingZoomLink : '',
    productionTrainingZoomPw :'',
    srw :'',
    clientSpecificLink : '',
    clientSpecificPw : '',
    rosterIdm : '',
    notes : '',
    traineeName : '',
    traineeEmail : '',
    ogName : '',
    ogEmail : '',
    tpcHostName : '',
    tpcHostEmail : '',
    TPCZoomHostKey : '',
    accna : false,
    nestingNA: false,
    tciRecoveryNA : false,
    tcina : false,
    techTestNA : false,
    techTestRecoveryNA :false,
    tpcna : false,
    ttfna : false,
    productTrainingNa : false,
    tpcHostOracleId : '',
    clientSpecificZoomHostKey : '',
    clientSpecificZoomLink: '',
    productionStartDateRequired :false,
    modifiedDate : '',
    rosterLockDate : '',
    askNowTDT:'' ,
    istentativettfdate:'',
    istentativeproducttrainingdate: '',
    istentativenestingdate:''   
}

const rosterConfigSlice = createSlice({
    name: 'generalStore',
    initialState: initialValues,
    reducers : {
        updateTrainerOracle(state, action) {
            state.trainerOracle = action.payload
        },
        updateOgOracle(state, action) {
            state.ogOracle = action.payload
        },
        updateTcpOracle(state, action) {
            state.tcpOracle = action.payload
        },
        updateApplyAll(state, action) {
            state.applyAll = action.payload
        },
        updateProductionStatRequired(state, action) {
            state.productionStartDateRequired = action.payload
        },
        techEquipmentSolution(state, action) {
            state.techEquipmentSolution = action.payload ? action.payload : ''
        },
        updateDistributionType(state, action) {
            state.distributionType = action.payload ? action.payload : ''
        },
        updateNetworkType(state, action) {
            state.networkType = action.payload ? action.payload : ''
        },
        accna(state, action) {
            state.accna = action.payload
        },
        nestingNA(state, action) {
            state.nestingNA = action.payload
        },
        tciRecoveryNA(state, action) {
            state.tciRecoveryNA = action.payload
        },
        tcina(state, action) {
            state.tcina = action.payload
        },
        techTestNA(state, action) {
            state.techTestNA = action.payload 
        },
        tpcna(state, action) {
            state.tpcna = action.payload 
        },
        ttfna(state, action) {
            state.ttfna = action.payload 
        },
        accDate(state, action) {
            state.accDate = action.payload ? action.payload : ''
        },
        tciDate(state, action) {
           state.tciDate = action.payload ? action.payload : '' 
        },
        tciRecoveryDate(state, action) {
            state.tciRecoveryDate = action.payload ? action.payload : ''
        },
        tpcRecoveryDate(state, action) {
            state.tpcRecoveryDate = action.payload ? action.payload : ''
        },
        tpcHostEmail(state, action) {
            state.tpcHostEmail = action.payload ? action.payload : ''
        },
        ttdBotDate(state, action) {
            state.ttdBotDate = action.payload ? action.payload : ''
        },
        ttdRecoveryDate(state, action) {
            state.ttdRecoveryDate = action.payload ? action.payload : ''
        },
        tpcDate(state, action) {
            state.tpcDate = action.payload ? action.payload : ''
        },
        ttfDate(state, action) {
            state.ttfDate = action.payload ? action.payload : ''
        },
        productTrainingDate(state, action) {
            state.productTrainingDate = action.payload ? action.payload : ''
        },
        nestingDate(state, action) {
            state.nestingDate = action.payload ? action.payload : ''
        },
        nestingEndDate(state, action) {
            state.nestingEndDate = action.payload ? action.payload : ''
        },
        productionStartDate(state, action) {
            state.productionStartDate = action.payload ? action.payload : ''
        },
        tciZoomLink(state, action) {
            state.tciZoomLink = action.payload ? action.payload : ''
        },
        tciZoomPw(state, action) {
            state.tciZoomPw = action.payload ? action.payload : ''
        },
        tciRecoveryZoomLink(state, action) {
            state.tciRecoveryZoomLink = action.payload ? action.payload : ''
        },
        tciRecoveryZoomPw(state, action) {
            state.tciRecoveryZoomPw = action.payload ? action.payload : ''
        },
        ttdZoomLink(state, action) {
            state.ttdZoomLink = action.payload ? action.payload : ''
        },
        ttdZoomPw(state, action) {
            state.ttdZoomPw = action.payload ? action.payload : ''
        },
        ttdRecoveryZoomLink(state, action) {
            state.ttdRecoveryZoomLink = action.payload ? action.payload : ''
        },
        ttdRecoveryZoomPw(state, action) {
            state.ttdRecoveryZoomPw = action.payload ? action.payload : ''
        },
        tpcZoomLink(state, action) {
            state.tpcZoomLink = action.payload ? action.payload : ''
        },
        tpcZoomPw(state, action) {
            state.tpcZoomPw = action.payload ? action.payload : ''
        },
        ttfZoomLink(state, action) {
            state.ttfZoomLink = action.payload ? action.payload : ''
        },
        tpcHostKey(state, action) {
            state.tpcHostKey = action.payload ? action.payload : ''
        },
        ttfHostKey(state, action) {
            state.ttfHostKey = action.payload ? action.payload : ''
        },
        ttfZoomPw(state, action) {
            state.ttfZoomPw = action.payload ? action.payload : ''
        },
        modifiedBy(state, action) {
            state.modifiedBy = action.payload ? action.payload : ''
        },
        updateModfiedDate(state, action) {
            state.modifiedDate = action.payload ? action.payload : ''
        },
        updateRosterLockDate(state, action) {
            state.rosterLockDate = action.payload ? action.payload : ''
        },
        updateAssignRosterLockDate(state, action) {
            state.updateAssignRosterLockDate = action.payload ? action.payload : ''
        }, 
        classRosterId(state, action) {
            state.classRosterId = action.payload ? action.payload : ''
        },
        wave(state, action) {
            state.wave = action.payload ? action.payload : ''
        },
        productionTrainingZoomLink(state, action) {
            state.productionTrainingZoomLink = action.payload ? action.payload : ''
        },
        productionTrainingZoomPw(state, action) {
            state.productionTrainingZoomPw = action.payload ? action.payload : ''
        },
        srw(state, action) {
            state.srw = action.payload ? action.payload : ''
        },
        clientSpecificLink(state, action) {
            state.clientSpecificLink = action.payload ? action.payload : ''
        },
        clientSpecificPw(state, action) {
            state.clientSpecificPw = action.payload ? action.payload : ''
        },
        rosterIdm(state, action) {
            state.rosterIdm = action.payload ? action.payload : ''
        },
        traineeName(state, action) {
            state.traineeName = action.payload ? action.payload : ' '
        },
        traineeEmail(state, action) {
            state.traineeEmail = action.payload ? action.payload : ''
        },

        clientSpecificZoomHostKey(state, action) {
            state.clientSpecificZoomHostKey = action.payload ? action.payload : ''
        },

        notes(state, action) {
            state.notes = action.payload ? action.payload : ''
        },
        ogName(state, action) {
            state.ogName = action.payload ? action.payload : ' '
        },
        ogEmail(state, action) {
            state.ogEmail = action.payload ? action.payload : ''
        },
        tpcHostName(state, action) {
            state.tpcHostName = action.payload ? action.payload : ' '
        },
        TPCZoomHostKey(state, action) {
            state.TPCZoomHostKey = action.payload ? action.payload : ''
        },
        tpcHostOracleId(state, action) {
            state.tpcHostOracleId = action.payload ? action.payload : ''
        },
        techTestRecoveryNA(state, action) {
            state.techTestRecoveryNA = action.payload
        },
        productTrainingNa(state, action) {
            state.productTrainingNa = action.payload ? action.payload : ''
        },
        istentativettfdate(state, action) {
            state.istentativettfdate = action.payload ;
        },
        istentativeproducttrainingdate(state, action) {
            state.istentativeproducttrainingdate = action.payload ;
        },
        istentativenestingdate(state, action) {
            state.istentativenestingdate = action.payload ;
        },
        resetRosterConfig: () => initialValues,       
        askNowTDT(state, action) {
            state.askNowTDT = action.payload ? action.payload : ''
        },
        
    }
})

export const rosterConfigAction = rosterConfigSlice.actions;

export default rosterConfigSlice.reducer;